import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const CATEGORIES = [
  "Artists",
  "Politicians",
  "Bloggers",
  "Military",
  "Officials",
  "Propagandists",
  "Businessmen",
  "Celebrities",
];

// Russian display labels (canonical values stay English to match backend)
export const CATEGORY_LABELS = {
  Artists: "Артисты",
  Politicians: "Политики",
  Bloggers: "Блогеры",
  Military: "Военные",
  Officials: "Чиновники",
  Propagandists: "Пропагандисты",
  Businessmen: "Бизнесмены",
  Celebrities: "Знаменитости",
};

export const catLabel = (c) => CATEGORY_LABELS[c] || c;
